import React from "react";
import Routes from "./Routes";
import AIChatWidget from './components/ai/AIChatWidget';

function App() {
  return (
    <>
      <Routes />
      <AIChatWidget />
    </>
  );
}

export default App;